<template>
  <div class="dashboard-root">
    <div class="flex items-center gap-20px mobile-header-content" @click="toggleMobileMenu">
      <span class="menu-toggle-btn">
        <i class="el-icon-s-fold" />
      </span>
      <div class="title" style="color: #A40000;">云南省高校人才市场</div>
    </div>
    <!-- 手机端遮罩 -->
    <div v-show="mobileMenuVisible" class="mobile-overlay" @click="closeMobileMenu" />
    <!-- 手机端侧边栏 -->
    <div v-show="mobileMenuVisible" class="mobile-sidebar" :class="{ 'mobile-open': mobileMenuVisible }">
      <div class="title">云南省高校人才市场</div>
      <div v-if="menuList.length && showMenu" class="menu">
        <template v-for="(item, index) in menuList">
          <div :key="item.path" class="menu-item" @click="meunItemClick({ item, index })">
            <div class="item-l" :class="{ 'active-bg': index === currentRouteIndex }">
              <img :src="getMenuIcon(index)" alt="" />
              <span class="title-text">
                {{ item.meta.title }}
              </span>
            </div>
            <div v-if="index === currentRouteIndex" class="icon-caret-left" />
          </div>
        </template>
        <div class="menu-item" @click="$router.push({ name: 'exam-examlist' })">
          <div class="item-l">
            <img :src="getMenuIcon(3)" alt="" />
            <span class="title-text"> 返回首页 </span>
          </div>
        </div>
      </div>
    </div>

    <el-container class="dashboard-container">
      <el-aside v-show="showMenu" class="dashboard-aside">
        <div class="title">云南省高校人才市场</div>
        <div v-if="menuList.length" class="menu">
        <template v-for="(item, index) in menuList">
          <div :key="item.path" class="menu-item" @click="meunItemClick({ item, index })">
            <div class="item-l" :class="{ 'active-bg': index === currentRouteIndex }">
              <img :src="getMenuIcon(index)" alt="" />
              <span class="title-text">
                {{ item.meta.title }}
              </span>
            </div>
            <div v-if="index === currentRouteIndex" class="icon-caret-left" />
          </div>
        </template>
        <div class="menu-item" @click="$router.push({ name: 'exam-examlist' })">
          <div class="item-l">
            <img :src="getMenuIcon(3)" alt="" />
            <span class="title-text"> 返回首页 </span>
          </div>
        </div>
        </div>
      </el-aside>
      <el-main class="dashboard-main">
        <div class="dashboard-header">
          <div class="flex items-center gap-20px">
            <img class="icon-user" src="@/assets/images/login/avatar.png" alt="" />
            <span>您好, {{ userInfo?.mobile }}</span>
            <!-- 审核结果提示暂不使用（站内信已覆盖通知），先注释 -->
            <!-- <span class="audit-tip" style="font-size: 14px;">{{ registrationInfo?.auditStatus == 3 ? '审核已被驳回，请前往“报名审核”菜单查看！'
              :
              '' }}</span> -->
          </div>
          <div class="flex items-center header-actions" style="cursor: pointer;">
            <!-- 岗位报名情况：报名中且考试开启展示时才出现，点击弹框查看 -->
            <div v-if="showPostStat" class="flex items-center gap-10px" @click="openPostStat">
              <i class="el-icon-data-analysis action-icon"></i>
              <span class="action-text">岗位报名情况</span>
            </div>
            <div v-if="showManual" class="flex items-center gap-10px" @click="openManual()">
              <img class="icon-logout" src="@/assets/images/login/zhinan.png" alt="" />
              <span class="action-text">操作手册</span>
            </div>
            <el-popover
              ref="messagePopover"
              v-model="messagePopoverVisible"
              popper-class="message-popover"
              placement="bottom-end"
              width="340"
              trigger="click"
            >
              <div class="message-popover">
                <div class="flex items-center justify-between popover-header">
                  <span class="popover-title">消息通知</span>
                  <el-button type="text" :disabled="unreadNotifyCount === 0" @click="handleReadAll">全部已读</el-button>
                </div>
                <div class="message-popover-body">
                  <div v-if="messageLoading" class="message-tip">加载中…</div>
                  <div v-else-if="messageList.length === 0" class="message-tip">暂无消息</div>
                  <template v-else>
                    <div
                      v-for="item in messageList"
                      :key="item.id"
                      class="message-item"
                      :class="{ unread: !item.readStatus }"
                      @click="openDetail(item)"
                    >
                      <span v-if="!item.readStatus" class="message-dot" />
                      <div class="message-item-content">
                        <div class="message-item-title">{{ item.templateNickname }}</div>
                        <div class="message-item-text">{{ item.templateContent }}</div>
                        <div class="message-item-time">{{ formatTime(item.createTime) }}</div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div slot="reference" class="flex items-center gap-10px message-bell">
                <el-badge :value="unreadNotifyCount" :hidden="unreadNotifyCount === 0" :max="99">
                  <i class="el-icon-message action-icon"></i>
                </el-badge>
                <span class="action-text">消息</span>
              </div>
            </el-popover>
            <div class="flex items-center gap-10px" @click="onLogout">
              <img class="icon-logout" src="@/assets/images/login/logout.png" alt="" />
              <span class="action-text">退出</span>
            </div>
          </div>
        </div>
        <div class="app-main">
          <router-view />
        </div>
      </el-main>
    </el-container>

    <!-- 岗位报名情况：帮助考生在选岗前了解各岗位报名热度 -->
    <el-dialog
      title="岗位报名情况"
      :visible.sync="postStatVisible"
      width="900px"
      append-to-body
    >
      <div style="margin-bottom: 12px; color: #909399; font-size: 12px;">数据实时统计，仅供参考</div>
      <el-table v-loading="postStatLoading" :data="postStatList" class="post-stat-table" border max-height="480">
        <el-table-column label="报考单位" prop="deptName" min-width="180" show-overflow-tooltip />
        <el-table-column label="报考岗位" prop="postName" min-width="150" show-overflow-tooltip />
        <el-table-column label="岗位代码" prop="postCode" width="110" align="center" />
        <el-table-column label="录用人数" prop="headcount" width="90" align="center" />
        <el-table-column label="报名人数" prop="signUpCount" width="90" align="center" />
        <el-table-column label="审核通过人数" prop="auditPassCount" width="110" align="center" />
        <el-table-column label="交费人数" prop="payCount" width="90" align="center" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as ExamRegistrationApi from "@/api/exam/registration";
import {
  getMyNotifyMessagePage,
  updateNotifyMessageRead,
  updateAllNotifyMessageRead,
} from "@/api/exam/notifyMessage";
import { parseTime } from "@/utils/ruoyi";

export default {
  data() {
    return {
      pageData: {},
      currentRouteIndex: 0,
      registrationInfo: {},
      mobileMenuVisible: false,
      unreadTimer: null,
      messageList: [],
      messageLoading: false,
      messagePopoverVisible: false,
      postStatVisible: false,
      postStatLoading: false,
      postStatList: [],
    };
  },
  computed: {
    ...mapGetters(["userInfo", "currentExamInfo", "unreadNotifyCount"]),
    // 报名列表页（登录默认页）不显示左侧菜单，点击"去报名"进入报名流程后才有菜单
    showMenu() {
      return this.$route.name !== "exam-examlist";
    },
    // 操作手册：仅在选择了某一场考试（进入报名流程）后才显示，且需存在有效考试
    showManual() {
      return this.$route.name !== "exam-examlist" && !!this.currentExamInfo?.id;
    },
    // 岗位报名情况：报名中且考试开启了「考生端展示报名统计」时才显示
    showPostStat() {
      return (
        this.$route.name !== "exam-examlist" &&
        !!this.currentExamInfo?.id &&
        Number(this.currentExamInfo?.status) === 1 &&
        Number(this.currentExamInfo?.postStatShow) === 1
      );
    },
    menuList() {
      const routes = this.$router.getRoutes();
      // 只展示未隐藏（meta.hidden !== true）的菜单项，报名列表页默认展示但不进菜单
      const filterRoutes = routes.filter(
        (item) => item.parent?.name === "dashboard" && !item.meta?.hidden,
      );
      // 报名缴费：仅当该考试开启收费（chargeFlag === 1）时才展示，关闭收费时隐藏菜单入口
      const charged = Number(this.currentExamInfo?.chargeFlag) === 1;
      return charged ? filterRoutes : filterRoutes.filter((item) => item.name !== "exam-pay");
    },
  },
  watch: {
    $route() {
      // 子页面跳转时同步菜单高亮；报名列表页（hidden）不高亮任何菜单
      const idx = this.menuList.findIndex((item) => item.name === this.$route.name);
      this.currentRouteIndex = idx;
    },
    // 打开消息弹层时拉取最近消息
    messagePopoverVisible(val) {
      if (val) {
        this.fetchMessageList();
      }
    },
  },
  async created() {
    this.registrationInfo = {};
    await this.$nextTick(async () => {
      await this.fetchExamDataList();
      if (this.currentExamInfo?.id) {
        const res = await ExamRegistrationApi.get({
          examId: this.currentExamInfo.id,
        });
        this.registrationInfo = res;
      }
      if (this.$route.query.index) {
        let index = Number(this.$route.query.index);
        this.meunItemClick({ item: { name: "exam-print" }, index: index });
      } else if (this.$route.name !== "exam-examlist") {
        // 登录后默认展示报名列表页（不在侧边栏菜单中）
        this.currentRouteIndex = -1;
        this.$router.replace({ name: "exam-examlist" });
      }
      // 轮询未读消息数（仅登录后展示菜单时）
      this.refreshUnreadCount();
      this.unreadTimer = setInterval(() => this.refreshUnreadCount(), 30000);
    });
  },
  beforeDestroy() {
    if (this.unreadTimer) {
      clearInterval(this.unreadTimer);
    }
  },
  methods: {
    ...mapActions(["LogOut", "fetchExamDataList", "fetchExamInfoById", "fetchUnreadNotifyCount"]),
    openManual() {
      // 操作手册展示当前所选考试上传的指南
      const examId = this.currentExamInfo?.id;
      if (!examId) {
        this.$message.warning("请先选择一场考试");
        return;
      }
      const routeUrl = this.$router.resolve({
        path: "/wordView",
        query: { examId },
      });
      window.open(routeUrl.href);
    },
    // 打开「岗位报名情况」弹框：每次打开都重新拉取，避免看到旧数据
    async openPostStat() {
      const examId = this.currentExamInfo?.id;
      if (!examId) {
        this.$message.warning("请先选择一场考试");
        return;
      }
      this.postStatVisible = true;
      this.postStatLoading = true;
      try {
        this.postStatList = (await ExamRegistrationApi.getPostStatList({ examId })) || [];
      } finally {
        this.postStatLoading = false;
      }
    },
    toggleMobileMenu() {
      this.mobileMenuVisible = !this.mobileMenuVisible;
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    closeMobileMenu() {
      this.mobileMenuVisible = false;
    },
    // 菜单图标：仅存在 icon_01~icon_05，菜单项超出数量时循环复用，避免 require 失败导致白屏
    getMenuIcon(index) {
      const iconNo = (index % 5) + 1;
      return require(`@/assets/images/menu/icon_0${iconNo}.png`);
    },
    meunItemClick({ item, index }) {
      this.currentRouteIndex = index;
      const currentRoute = this.$route;
      if (currentRoute.name === item.name) return;
      this.$router.push({ name: item.name });
      if (this.mobileMenuVisible) {
        this.mobileMenuVisible = false;
      }
    },
    onLogout() {
      this.LogOut().then(() => {
        // this.$router.push("/login");
        this.$router.push("/");
      });
    },
    async refreshUnreadCount() {
      // 统一走 store，标记已读后可立即刷新角标
      await this.fetchUnreadNotifyCount();
    },
    // 打开消息弹层时拉取最近消息
    async fetchMessageList() {
      this.messageLoading = true;
      try {
        const data = await getMyNotifyMessagePage({ pageNo: 1, pageSize: 10 });
        this.messageList = data?.list || [];
      } catch (e) {
        this.messageList = [];
      } finally {
        this.messageLoading = false;
      }
    },
    // 点击单条消息：未读则标记已读并刷新
    async openDetail(item) {
      if (!item.readStatus) {
        await updateNotifyMessageRead([item.id]);
        await this.fetchUnreadNotifyCount();
        this.fetchMessageList();
      }
    },
    // 全部标记为已读
    async handleReadAll() {
      await updateAllNotifyMessageRead();
      this.$message.success("已全部标记为已读");
      await this.fetchUnreadNotifyCount();
      this.fetchMessageList();
      this.messagePopoverVisible = false;
    },
    formatTime(time) {
      if (!time) return "";
      return parseTime(time, "{y}-{m}-{d} {h}:{i}");
    },
  },
};
</script>

<style scoped lang="scss">
.mobile-header-content {
  display: none;
}

.dashboard-root {
  width: 100vw;
  height: 100vh;
}

.dashboard-container {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 10px;
  font-size: 19px;
  overflow: hidden;
}

.menu-toggle-btn {
  display: none;
  font-size: 22px;
  cursor: pointer;
  color: #A40000;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.mobile-overlay {
  /* v-show 控制显示，移动端样式在 media query 中 */
}

.mobile-sidebar {
  /* v-show 控制显示，移动端样式在 media query 中 */
}

:deep(.el-aside) {
  box-sizing: border-box;
  width: 260px !important;
  height: 100%;
  background: linear-gradient(180deg, #A40000 0%, #CC3B16 100%);
  border-radius: 32px 0px 0px 32px;
  color: #ffffff;

  .title-text {
    width: 140px;
  }

  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70px;
    font-weight: bold;
  }

  .menu-item {
    position: relative;
    cursor: pointer;

    .item-l {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 14px;
      box-sizing: border-box;
      width: 230px;
      height: 80px;
    }

    .active-bg {
      background-image: url("@/assets/images/menu/active.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }

    .icon-caret-left {
      position: absolute;
      top: calc(50% - 12px);
      right: 0;
      border-top: 12px solid transparent;
      border-bottom: 12px solid transparent;
      border-right: 12px solid #f0f2f5;
    }
  }
}

.dashboard-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px 0;
  box-sizing: border-box;
  padding: 0;
  margin-left: 20px;

  .dashboard-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 70px;
    padding: 0 28px 0 35px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
    border-radius: 0px 26px 0px 0px;
    font-size: 16px;

    .icon-user {
      width: 32px;
      height: 32px;
    }

    .icon-logout {
      width: 24px;
      height: 24px;
      object-fit: contain;
      flex-shrink: 0;
    }

    .header-actions {
      /* 操作手册/消息/退出 统一间距，避免"消息"和"退出"挤在一起 */
      gap: 40px;

      /* 顶部图标统一使用品牌色 #A40000，尺寸与两侧图片图标保持一致（24px） */
      .action-icon {
        display: inline-block;
        font-size: 24px;
        line-height: 1;
        color: #a40000;
      }

      /* 未读角标浮在图标右上角，预留位置避免压住"消息"文字 */
      .message-bell .el-badge {
        margin-right: 6px;
      }
    }
  }

  .app-main {
    flex: 1;
    height: calc(100% - 70px);
    overflow-y: auto;
    background: #ffffff;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
  }
}

/* 大屏笔记本/外接显示器（15.6寸+，100%或低缩放）*/
@media (min-width: 1537px) and (max-width: 1920px) {
  .dashboard-container {
    font-size: 24px;
  }

  :deep(.el-aside) {
    width: 320px !important;

    .title-text {
      width: 170px;
    }

    .menu-item {
      .title {
        height: 88px;
      }

      .item-l {
        width: 279px;
        height: 100px;
      }
    }
  }

  .dashboard-header {
    height: 88px;
    padding: 0 35px 0 40px;
    font-size: 20px;

    .icon-user {
      width: 40px;
      height: 40px;
    }

    .icon-logout {
      width: 30px;
      height: 30px;
      object-fit: contain;
      flex-shrink: 0;
    }

    .header-actions {
      gap: 50px;

      /* 大屏下同样保持三者一致（30px） */
      .action-icon {
        font-size: 30px;
      }
    }
  }

  .app-main {
    height: calc(100% - 88px);
  }
}

/* 平板端适配 */
@media screen and (max-width: 1024px) {

  .dashboard-container {
    font-size: 16px;
  }

  :deep(.el-aside) {
    width: 200px !important;

    .title {
      font-size: 16px;
      height: 60px;
    }

    .title-text {
      width: 110px;
    }

    .menu-item .item-l {
      width: 175px;
      height: 60px;
      gap: 10px;

      img {
        width: 24px;
        height: 24px;
      }
    }
  }

  .dashboard-main {
    margin-left: 14px;
    gap: 14px 0;

    .dashboard-header {
      height: 60px;
      padding: 0 16px 0 20px;
      font-size: 14px;

      .icon-user {
        width: 26px;
        height: 26px;
      }

      .icon-logout {
        width: 20px;
        height: 20px;
      }

      .header-actions {
        gap: 20px;

        .action-text {
          display: none;
        }
      }

      .audit-tip {
        display: none;
      }
    }

    .app-main {
      height: calc(100% - 74px);
    }
  }
}

/* 手机端适配 */
@media screen and (max-width: 768px) {
  .mobile-header-content {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 44px;
    padding: 0 12px;
    box-sizing: border-box;
    background: #fff;
    z-index: 101;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
    touch-action: manipulation;
  }

  .dashboard-container {
    padding: 0;
    padding-top: 44px;
    font-size: 14px;
    overflow: visible;
  }

  .menu-toggle-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    font-size: 22px;
    flex-shrink: 0;
  }

  .mobile-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.45);
    z-index: 999;
  }

  .mobile-sidebar {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 240px;
    z-index: 1000;
    background: linear-gradient(180deg, #A40000 0%, #CC3B16 100%);
    color: #ffffff;
    transform: translateX(-100%);
    transition: transform 0.3s ease;

    &.mobile-open {
      transform: translateX(0);
    }

    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 56px;
      font-size: 18px;
      font-weight: bold;
    }

    .title-text {
      width: 130px;
    }

    .menu-item {
      position: relative;
      cursor: pointer;

      .item-l {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        box-sizing: border-box;
        width: 210px;
        height: 56px;

        img {
          width: 24px;
          height: 24px;
        }
      }

      .active-bg {
        background-image: url("@/assets/images/menu/active.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }

      .icon-caret-left {
        position: absolute;
        top: calc(50% - 12px);
        right: 0;
        border-top: 12px solid transparent;
        border-bottom: 12px solid transparent;
        border-right: 12px solid #f0f2f5;
      }
    }
  }

  /* 隐藏桌面端侧边栏 */
  :deep(.el-aside) {
    display: none;
  }

  .dashboard-main {
    margin-left: 0;
    gap: 0;
    overflow: hidden;

    .dashboard-header {
      height: 52px;
      padding: 0 12px;
      font-size: 13px;
      border-radius: 0;
      gap: 8px;

      .gap-20px {
        gap: 8px;
      }

      .icon-user {
        width: 24px;
        height: 24px;
      }

      .icon-logout {
        width: 18px;
        height: 18px;
      }

      .header-actions {
        gap: 12px;

        .action-text {
          display: none;
        }

        >div.gap-10px {
          gap: 4px;
        }
      }

      .audit-tip {
        display: none;
      }
    }

    .app-main {
      flex: 1;
      height: auto;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      border-radius: 0;
      box-shadow: none;
    }
  }
}
</style>

<style lang="scss">
/* 岗位报名情况弹框（append-to-body 到 body，故用全局样式） */
.post-stat-table.el-table {
  font-size: 15px;
}

/* 消息弹层（teleport 到 body，故用全局样式） */
.el-popover.message-popover {
  padding: 0;
}

.message-popover {
  .popover-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;

    .popover-title {
      font-weight: 600;
      color: #303133;
    }
  }

  .message-popover-body {
    max-height: 320px;
    overflow-y: auto;

    .message-tip {
      padding: 36px 0;
      text-align: center;
      color: #909399;
      font-size: 14px;
    }

    .message-item {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      padding: 12px 16px;
      cursor: pointer;
      border-bottom: 1px solid #f5f5f5;

      &:hover {
        background: #fafafa;
      }

      &.unread {
        background: #fff7f7;
      }

      .message-dot {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        margin-top: 6px;
        border-radius: 50%;
        background: #a40000;
      }

      .message-item-content {
        flex: 1;
        min-width: 0;
      }

      .message-item-title {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
      }

      // 审核通知正文较长（含审核结果/审核意见/说明），此处不做行数截断；
      // 点击消息只标记已读、没有详情弹窗，截断会导致全文无处可看
      .message-item-text {
        margin: 4px 0;
        font-size: 13px;
        line-height: 1.5;
        color: #606266;
        word-break: break-all;
        white-space: pre-wrap;
      }

      .message-item-time {
        font-size: 12px;
        color: #c0c4cc;
      }
    }
  }
}
</style>
